import { Link, generatePath } from "react-router-dom";
import { DATE_FORMAT, userFullName } from "helpers/common";
import * as Path from 'routes/paths';

const EntityDetails = ({ data }) => {
    return (
        <>
            {/* Entity Detail */}
            {data.entity_type === "todo" && data.todo && (
                <>
                    <h6 className="text-primary mb-3">Todo Details</h6>

                    <div className="form-group row">
                        <label className="col-sm-4 col-form-label">Form Name</label>
                        <div className="col-sm-8">
                            <p className="form-control-plaintext">
                                {data.todo.form_name}
                            </p>
                        </div>
                    </div>

                    <div className="form-group row">
                        <label className="col-sm-4 col-form-label">Todo Status</label>
                        <div className="col-sm-8">
                            <span className="badge bg-primary text-capitalize">
                                {data.todo.status}
                            </span>
                        </div>
                    </div>

                    {data?.metadata?.status && (
                        <div className="form-group row">
                            <label className="col-sm-4 col-form-label">Previous Status</label>
                            <div className="col-sm-8">
                                <span className="badge bg-primary text-capitalize">
                                    {data?.metadata?.status}
                                </span>
                            </div>
                        </div>
                    )}

                    {data?.todo?.id && (
                        <div className="form-group row">
                            <label className="col-sm-4 col-form-label">Todo ID</label>
                            <div className="col-sm-8">
                                <p className="mb-0">{data.todo.id}</p>
                            </div>
                        </div>
                    )}

                    <div className="form-group row">
                        <label className="col-sm-4 col-form-label">Client Name</label>
                        <div className="col-sm-8">
                            <p className="mb-0">
                                {data.todo.client_status === "archived" ? (
                                    <>{userFullName(data.todo)} {data.todo.email ? <span className="text-muted">({data.todo.email})</span> : ""}</>
                                ):(
                                    <Link
                                        to={generatePath(Path.practitioner_view, { id: data.pract_id })}
                                        target={"_blank"}
                                    >
                                        {userFullName(data.todo)} {data.todo.email ? <span className="text-muted">({data.todo.email})</span> : ""}
                                    </Link>
                                )}
                            </p>
                        </div>
                    </div>

                    <div className="form-group row">
                        <label className="col-sm-4 col-form-label">Client Status</label>
                        <div className="col-sm-8">
                            <span className="badge bg-primary text-capitalize">
                                {data.todo.client_status}
                            </span>
                        </div>
                    </div>

                    <div className="form-group row">
                        <label className="col-sm-4 col-form-label">Created At</label>
                        <div className="col-sm-8">
                            <p className="form-control-plaintext">
                                {DATE_FORMAT(data.todo.created_at, "MMM D, YYYY H:mm A")}
                            </p>
                        </div>
                    </div>

                    <div className="form-group row">
                        <label className="col-sm-4 col-form-label">Updated At</label>
                        <div className="col-sm-8">
                            <p className="form-control-plaintext">
                                {DATE_FORMAT(data.todo.updated_at, "MMM D, YYYY H:mm A")}
                            </p>
                        </div>
                    </div>
                </>
            )}

            {data.entity_type === "client" && data.client && (
                <>
                    <h6 className="text-primary mb-3">Client Details</h6>

                    <div className="form-group row">
                        <label className="col-sm-4 col-form-label">Client Name</label>
                        <div className="col-sm-8">
                            <p className="mb-0">
                                {data?.status === "restored" ? (    
                                    <Link
                                        to={generatePath(Path.client_view, { id: data.client.id })}
                                        target={"_blank"}
                                    >
                                        {userFullName(data.client)} {data.client.email ? <span className="text-muted">({data.client.email})</span> : ""}
                                    </Link>
                                ):(
                                    <>{userFullName(data.client)} {data.client.email ? <span className="text-muted">({data.client.email})</span> : ""}</>
                                )}
                            </p>
                        </div>
                    </div>

                    {data?.metadata?.status && (
                        <div className="form-group row">
                            <label className="col-sm-4 col-form-label">Previous Status</label>
                            <div className="col-sm-8">
                                <span className="badge bg-primary text-capitalize">
                                    {data?.metadata?.status}
                                </span>
                            </div>
                        </div>
                    )}

                    <div className="form-group row">
                        <label className="col-sm-4 col-form-label">Client ID</label>
                        <div className="col-sm-8">
                            <p className="form-control-plaintext">
                                {data.client.id}
                            </p>
                        </div>
                    </div>

                    <div className="form-group row">
                        <label className="col-sm-4 col-form-label">Created At</label>
                        <div className="col-sm-8">
                            <p className="form-control-plaintext">
                                {DATE_FORMAT(data.client.created_at, "MMM D, YYYY H:mm A")}
                            </p>
                        </div>
                    </div>

                    <div className="form-group row">
                        <label className="col-sm-4 col-form-label">Updated At</label>
                        <div className="col-sm-8">
                            <p className="form-control-plaintext">
                                {DATE_FORMAT(data.client.updated_at, "MMM D, YYYY H:mm A")}
                            </p>
                        </div>
                    </div>
                </>
            )}

            {data.entity_type === "tag" && data.tag && (
                <>
                    <h6 className="text-primary mb-3">Tag Details</h6>

                    <div className="form-group row">
                        <label className="col-sm-4 col-form-label">Tag Name</label>
                        <div className="col-sm-8">
                            <p className="mb-0">{data.tag.name}</p>
                        </div>
                    </div>

                    {data?.metadata?.status && (
                        <div className="form-group row">
                            <label className="col-sm-4 col-form-label">Previous Status</label>
                            <div className="col-sm-8">
                                <span className="badge bg-primary text-capitalize">
                                    {data?.metadata?.status}
                                </span>
                            </div>
                        </div>
                    )}

                    {data?.tag?.status && (
                        <div className="form-group row">
                            <label className="col-sm-4 col-form-label">Current Status</label>
                            <div className="col-sm-8">
                                <span className="badge bg-primary text-capitalize">
                                    {data?.tag?.status}
                                </span>
                            </div>
                        </div>
                    )}

                    {data?.tag?.id && (
                        <div className="form-group row">
                            <label className="col-sm-4 col-form-label">Tag ID</label>
                            <div className="col-sm-8">
                                <p className="mb-0">{data.tag.id}</p>
                            </div>
                        </div>
                    )}

                    <div className="form-group row">
                        <label className="col-sm-4 col-form-label">Created At</label>
                        <div className="col-sm-8">
                            <p className="form-control-plaintext">
                                {DATE_FORMAT(data.tag.created_at, "MMM D, YYYY H:mm A")}
                            </p>
                        </div>
                    </div>
                </>
            )}

            {data.entity_type === "document" && data.document && (
                <>
                    <h6 className="text-primary mb-3">Document Details</h6>

                    <div className="form-group row">
                        <label className="col-sm-4 col-form-label">Document Name</label>
                        <div className="col-sm-8">
                            <p className="mb-0">{data.document.name}</p>
                        </div>
                    </div>

                    {data?.metadata?.status && (
                        <div className="form-group row">
                            <label className="col-sm-4 col-form-label">Previous Status</label>
                            <div className="col-sm-8">
                                <span className="badge bg-primary text-capitalize">
                                    {data?.metadata?.status}
                                </span>
                            </div>
                        </div>
                    )}

                    {data?.document?.status && (
                        <div className="form-group row">
                            <label className="col-sm-4 col-form-label">Current Status</label>
                            <div className="col-sm-8">
                                <span className="badge bg-primary text-capitalize">
                                    {data?.document?.status}
                                </span>
                            </div>
                        </div>
                    )}

                    {data?.document?.id && (
                        <div className="form-group row">
                            <label className="col-sm-4 col-form-label">Document ID</label>
                            <div className="col-sm-8">
                                <p className="mb-0">{data.document.id}</p>
                            </div>
                        </div>
                    )}

                    <div className="form-group row">
                        <label className="col-sm-4 col-form-label">Created At</label>
                        <div className="col-sm-8">
                            <p className="form-control-plaintext">
                                {DATE_FORMAT(data.document.created_at, "MMM D, YYYY H:mm A")}
                            </p>
                        </div>
                    </div>
                </>
            )}

            {data.entity_type === "form" && data.form && (
                <>
                    <h6 className="text-primary mb-3">Form Details</h6>

                    <div className="form-group row">
                        <label className="col-sm-4 col-form-label">Form Name</label>
                        <div className="col-sm-8">
                            <p className="mb-0">{data.form.form_name}</p>
                        </div>
                    </div>

                    <div className="form-group row">
                        <label className="col-sm-4 col-form-label">Form Visibility</label>
                        <div className="col-sm-8">
                            <p className="mb-0">{
                                data.form.form_type === "practitioner" ? "Practitioner Facing"
                                : data.form.form_type === "client" ? "Client Facing"
                                : data.form.form_type === "both" && "Practitioner and Client facing"

                            }</p>
                        </div>
                    </div>

                    {data?.metadata?.status && (
                        <div className="form-group row">
                            <label className="col-sm-4 col-form-label">Previous Status</label>
                            <div className="col-sm-8">
                                <span className="badge bg-primary text-capitalize">
                                    {data?.metadata?.status}
                                </span>
                            </div>
                        </div>
                    )}

                    {data?.form?.status && (
                        <div className="form-group row">
                            <label className="col-sm-4 col-form-label">Current Status</label>
                            <div className="col-sm-8">
                                <span className="badge bg-primary text-capitalize">
                                    {data?.form?.status}
                                </span>
                            </div>
                        </div>
                    )}

                    {data?.form?.id && (
                        <div className="form-group row">
                            <label className="col-sm-4 col-form-label">Form ID</label>
                            <div className="col-sm-8">
                                <p className="mb-0">{data.form.id}</p>
                            </div>
                        </div>
                    )}

                    <div className="form-group row">
                        <label className="col-sm-4 col-form-label">Created At</label>
                        <div className="col-sm-8">
                            <p className="form-control-plaintext">
                                {DATE_FORMAT(data.form.created_at, "MMM D, YYYY H:mm A")}
                            </p>
                        </div>
                    </div>
                </>
            )}

            {data.entity_type === "package" && data.package && (
                <>
                    <h6 className="text-primary mb-3">Package Details</h6>

                    <div className="form-group row">
                        <label className="col-sm-4 col-form-label">Package Name</label>
                        <div className="col-sm-8">
                            <p className="mb-0">{data.package.package_name}</p>
                        </div>
                    </div>

                    {data?.metadata?.status && (
                        <div className="form-group row">
                            <label className="col-sm-4 col-form-label">Previous Status</label>
                            <div className="col-sm-8">
                                <span className="badge bg-primary text-capitalize">
                                    {data?.metadata?.status}
                                </span>
                            </div>
                        </div>
                    )}

                    {data?.package?.status && (
                        <div className="form-group row">
                            <label className="col-sm-4 col-form-label">Current Status</label>
                            <div className="col-sm-8">
                                <span className="badge bg-primary text-capitalize">
                                    {data?.package?.status}
                                </span>
                            </div>
                        </div>
                    )}

                    {data?.package?.id && (
                        <div className="form-group row">
                            <label className="col-sm-4 col-form-label">Package ID</label>
                            <div className="col-sm-8">
                                <p className="mb-0">{data.package.id}</p>
                            </div>
                        </div>
                    )}

                    <div className="form-group row">
                        <label className="col-sm-4 col-form-label">Created At</label>
                        <div className="col-sm-8">
                            <p className="form-control-plaintext">
                                {DATE_FORMAT(data.package.created_at, "MMM D, YYYY H:mm A")}
                            </p>
                        </div>
                    </div>
                </>
            )}

            {data.entity_type === "client_document" && data.client_document && (
                <>
                    <h6 className="text-primary mb-3">Document Details</h6>

                    <div className="form-group row">
                        <label className="col-sm-4 col-form-label">Document Name</label>
                        <div className="col-sm-8">
                            <p className="mb-0">{data.client_document.document_name}</p>
                        </div>
                    </div>

                    {data?.metadata?.status && (
                        <div className="form-group row">
                            <label className="col-sm-4 col-form-label">Previous Status</label>
                            <div className="col-sm-8">
                                <span className="badge bg-primary text-capitalize">
                                    {data?.metadata?.status}
                                </span>
                            </div>
                        </div>
                    )}

                    {data?.client_document?.status && (
                        <div className="form-group row">
                            <label className="col-sm-4 col-form-label">Current Status</label>
                            <div className="col-sm-8">
                                <span className="badge bg-primary text-capitalize">
                                    {data?.client_document?.status}
                                </span>
                            </div>
                        </div>
                    )}

                    {data?.client_document?.id && (
                        <div className="form-group row">
                            <label className="col-sm-4 col-form-label">Document ID</label>
                            <div className="col-sm-8">
                                <p className="mb-0">{data.client_document.id}</p>
                            </div>
                        </div>
                    )}

                    {data?.client_document?.first_name && (
                        <div className="form-group row">
                            <label className="col-sm-4 col-form-label">Client Name</label>
                            <div className="col-sm-8">
                                <p className="mb-0">
                                    {data?.client_document?.client_status === "active" ? (    
                                        <Link
                                            to={generatePath(Path.client_view, { id: data.client_document.client_id })}
                                            target={"_blank"}
                                        >
                                            {userFullName(data.client_document)} {data.client_document.email ? <span className="text-muted">({data.client_document.email})</span> : ""}
                                        </Link>
                                    ):(
                                        <>{userFullName(data.client_document)} {data.client_document.email ? <span className="text-muted">({data.client_document.email})</span> : ""}</>
                                    )}
                                </p>
                            </div>
                        </div>
                    )}

                    <div className="form-group row">
                        <label className="col-sm-4 col-form-label">Created At</label>
                        <div className="col-sm-8">
                            <p className="form-control-plaintext">
                                {DATE_FORMAT(data.client_document.created_at, "MMM D, YYYY H:mm A")}
                            </p>
                        </div>
                    </div>
                </>
            )}

            {data.entity_type === "document_note" && data.document_note && (
                <>
                    <h6 className="text-primary mb-3">Note Details</h6>

                    <div className="form-group row">
                        <label className="col-sm-4 col-form-label">Document Name</label>
                        <div className="col-sm-8">
                            <p className="mb-0">{data.document_note.document_name}</p>
                        </div>
                    </div>

                    {data?.metadata?.status && (
                        <div className="form-group row">
                            <label className="col-sm-4 col-form-label">Previous Status</label>
                            <div className="col-sm-8">
                                <span className="badge bg-primary text-capitalize">
                                    {data?.metadata?.status}
                                </span>
                            </div>
                        </div>
                    )}

                    {data?.document_note?.status && (
                        <div className="form-group row">
                            <label className="col-sm-4 col-form-label">Current Status</label>
                            <div className="col-sm-8">
                                <span className="badge bg-primary text-capitalize">
                                    {data?.document_note?.status}
                                </span>
                            </div>
                        </div>
                    )}

                    {data?.document_note?.id && (
                        <div className="form-group row">
                            <label className="col-sm-4 col-form-label">Note ID</label>
                            <div className="col-sm-8">
                                <p className="mb-0">{data.document_note.id}</p>
                            </div>
                        </div>
                    )}

                    {data?.document_note?.first_name && (
                        <div className="form-group row">
                            <label className="col-sm-4 col-form-label">Client Name</label>
                            <div className="col-sm-8">
                                <p className="mb-0">
                                    {data?.document_note?.client_status === "active" ? (    
                                        <Link
                                            to={generatePath(Path.client_view, { id: data.document_note.client_id })}
                                            target={"_blank"}
                                        >
                                            {userFullName(data.document_note)} {data.document_note.email ? <span className="text-muted">({data.document_note.email})</span> : ""}
                                        </Link>
                                    ):(
                                        <>{userFullName(data.document_note)} {data.document_note.email ? <span className="text-muted">({data.document_note.email})</span> : ""}</>
                                    )}
                                </p>
                            </div>
                        </div>
                    )}

                    <div className="form-group row">
                        <label className="col-sm-4 col-form-label">Created At</label>
                        <div className="col-sm-8">
                            <p className="form-control-plaintext">
                                {DATE_FORMAT(data.document_note.created_at, "MMM D, YYYY H:mm A")}
                            </p>
                        </div>
                    </div>
                </>
            )}

            {data.entity_type === "notes" && data.notes && (
                <>
                    <h6 className="text-primary mb-3">Note Details</h6>

                    {data?.metadata?.status && (
                        <div className="form-group row">
                            <label className="col-sm-4 col-form-label">Previous Status</label>
                            <div className="col-sm-8">
                                <span className="badge bg-primary text-capitalize">
                                    {data?.metadata?.status}
                                </span>
                            </div>
                        </div>
                    )}

                    {data?.notes?.status && (
                        <div className="form-group row">
                            <label className="col-sm-4 col-form-label">Current Status</label>
                            <div className="col-sm-8">
                                <span className="badge bg-primary text-capitalize">
                                    {data?.notes?.status}
                                </span>
                            </div>
                        </div>
                    )}

                    {data?.notes?.id && (
                        <div className="form-group row">
                            <label className="col-sm-4 col-form-label">Note ID</label>
                            <div className="col-sm-8">
                                <p className="mb-0">{data.notes.id}</p>
                            </div>
                        </div>
                    )}

                    {data?.notes?.first_name && (
                        <div className="form-group row">
                            <label className="col-sm-4 col-form-label">Client Name</label>
                            <div className="col-sm-8">
                                <p className="mb-0">
                                    {data?.notes?.client_status === "active" ? (    
                                        <Link
                                            to={generatePath(Path.client_view, { id: data.notes.client_id })}
                                            target={"_blank"}
                                        >
                                            {userFullName(data.notes)} {data.notes.email ? <span className="text-muted">({data.notes.email})</span> : ""}
                                        </Link>
                                    ):(
                                        <>{userFullName(data.notes)} {data.notes.email ? <span className="text-muted">({data.notes.email})</span> : ""}</>
                                    )}
                                </p>
                            </div>
                        </div>
                    )}

                    <div className="form-group row">
                        <label className="col-sm-4 col-form-label">Created At</label>
                        <div className="col-sm-8">
                            <p className="form-control-plaintext">
                                {DATE_FORMAT(data.notes.created_at, "MMM D, YYYY H:mm A")}
                            </p>
                        </div>
                    </div>
                </>
            )}
        </>
    )
}

export default EntityDetails;